<template>
  <component
    :is="href ? 'a' : 'button'"
    role="menuitem"
    :href="href"
    :type="href ? undefined : 'button'"
    class="font-display text-ink flex items-center gap-2.5 rounded-xl px-3 py-2.25 text-[13px] font-semibold no-underline transition-colors"
    :class="toneClasses"
  >
    <span v-if="$slots.icon" class="flex shrink-0 opacity-70" aria-hidden="true"><slot name="icon" /></span>
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Renders an `<a>`; omit for a `<button>`. */
    href?: string
    /** `danger` for destructive entries (logout, delete). */
    tone?: 'default' | 'danger'
  }>(),
  { href: undefined, tone: 'default' },
)

const toneClasses = computed(
  () =>
    ({
      default: 'hover:bg-grey-100 dark:hover:bg-white/5',
      danger: 'hover:text-invoxia-red dark:hover:bg-invoxia-red/15 dark:hover:text-invoxia-red hover:bg-[#ffe7e7]',
    })[props.tone],
)
</script>
